type AmsStreamDataSourceKey = 'ams_stream_facts'

type OrgDataSourceKey = 'org_facts' | 'org_performance_facts'

export type InsightDataSourceKey =
    | 'campaign_keyword_opportunity'
    | 'campaign_negative_keyword_opportunity'
    | 'campaign_roi_automation_opportunity'
    | 'tip'

type AdvertisingDataSourceKey =
    | 'campaign_facts'
    | 'keyword_facts'
    | 'product_ad_facts'
    | 'target_facts'
    | 'sb_purchased_product_facts'
    | AmsStreamDataSourceKey

type AdGroupDataSourceKey = 'ad_group_facts'

type DspDataSourceKey =
    | 'dsp_campaign_facts'
    | 'dsp_inventory_facts'
    | 'dsp_audience_facts'

type MarketIntelligenceDataSourceKey =
    | 'sov_search_results'
    | 'sov_keyword_research'
    | 'segment_facts'
    | 'category_insights_facts'
    | 'sales_estimates'
    | 'market_analysis_segments'

type PerformanceFactsDataSourceKey = 'performance_facts'

type SellingPartnerDataSourceKey = 'all_selling_partner_products_facts'

type SellerCentralDataSourceKey =
    | 'sc_sales_and_traffic'
    | 'sc_all_orders'
    | 'sc_seller_analytics'

type VendorCentralDiagnosticDataSourceKey =
    | 'vc_api_sales_diagnostic'
    | 'vc_api_sales_diagnostic_sourcing'
    | 'vc_api_inventory_manufacturing'
    | 'vc_api_inventory_sourcing'

type VendorCentralDataSourceKey =
    | VendorCentralDiagnosticDataSourceKey
    | 'vc_api_inventory_health'

type LegacyVendorCentralDataSourceKey =
    | 'vc_sales_diagnostic'
    | 'vc_source_sales_diagnostic'
    | 'vc_inventory_health'
    | 'vc_traffic_diagnostic'

type DownstreamDataSourceKey = 'changelog' | 'asin_usage'

type AlertOnlyDataSourceKey =
    | 'sov_keyword_facts'
    | 'dsp_line_item_facts'
    | 'vc_sales_diagnostic_facts'
    | 'vc_inventory_health_facts'
    | 'vc_inventory_manufacturing_facts'
    | 'vc_inventory_sourcing_facts'
    | 'vc_sales_diagnostic_sourcing_facts'
    | 'portfolio_facts'
    | 'dsp_order_facts'

export type AlertDataSourceKey =
    | AlertOnlyDataSourceKey
    | Exclude<
          AdvertisingDataSourceKey,
          | 'product_ad_facts'
          | AmsStreamDataSourceKey
          | 'sb_purchased_product_facts'
      >
    | AdGroupDataSourceKey

export type RulebookDataSourceKey = Exclude<
    AlertDataSourceKey,
    'sov_keyword_facts'
>

export type DataSourceKey =
    | OrgDataSourceKey
    | AdvertisingDataSourceKey
    | AlertDataSourceKey
    | DspDataSourceKey
    | MarketIntelligenceDataSourceKey
    | SellerCentralDataSourceKey
    | VendorCentralDataSourceKey
    | LegacyVendorCentralDataSourceKey
    | DownstreamDataSourceKey
    | SellingPartnerDataSourceKey
    | '' // used for text widget data source

export type WidgetDataSourceKey = Exclude<
    DataSourceKey,
    AlertOnlyDataSourceKey | SellingPartnerDataSourceKey
>

export type FilterableDataSourceKey = Exclude<
    WidgetDataSourceKey,
    | 'ad_group_facts'
    | 'org_performance_facts'
    | 'sales_estimates'
    | 'sov_keyword_research'
    | ''
>

// Datasource keys that we have integration info
// for in /api/organization/{orgId}/account_status
export type OrgAccountStatusDataSourceKey =
    | AdvertisingDataSourceKey
    | DspDataSourceKey
    | MarketIntelligenceDataSourceKey
    | SellerCentralDataSourceKey
    | VendorCentralDataSourceKey
    | LegacyVendorCentralDataSourceKey
    | PerformanceFactsDataSourceKey

// Validate keys that we have integration info for
// so we can narrow widget data source types to those we have info for
export const isKeyInOrgAccountStatusDataSources = (
    dataSource: WidgetDataSourceKey
): dataSource is Exclude<
    OrgAccountStatusDataSourceKey,
    'performance_facts'
> => {
    return (
        dataSource === 'campaign_facts' ||
        dataSource === 'keyword_facts' ||
        dataSource === 'product_ad_facts' ||
        dataSource === 'target_facts' ||
        dataSource === 'ams_stream_facts' ||
        dataSource === 'dsp_campaign_facts' ||
        dataSource === 'dsp_inventory_facts' ||
        dataSource === 'sov_search_results' ||
        dataSource === 'segment_facts' ||
        dataSource === 'sc_sales_and_traffic' ||
        dataSource === 'sc_all_orders' ||
        dataSource === 'vc_api_sales_diagnostic' ||
        dataSource === 'vc_api_sales_diagnostic_sourcing' ||
        dataSource === 'vc_api_inventory_health' ||
        dataSource === 'vc_sales_diagnostic' ||
        dataSource === 'vc_source_sales_diagnostic' ||
        dataSource === 'vc_traffic_diagnostic' ||
        dataSource === 'vc_inventory_health' ||
        dataSource === 'sb_purchased_product_facts'
    )
}
